module.exports = __webpack_public_path__ + "img/public/SiteIcons/carIconNew.svg?54cbc754";